<template>
  <div>
    <el-scrollbar>
      <slot></slot>
    </el-scrollbar>
  </div>
</template>

<script>
import scrollbarWidth from 'element-ui/src/utils/scrollbar-width';

export default {
  props: {
    //自定义将需要显示的大小
    customHeight: {
      type: String,
      default: '100vh'
    }
  },
  name: "YlScrollBar",
  mounted() {
    //this.$el代表当前页面上的dom结点
    let scrollbarWidthSize = scrollbarWidth()
    this.$el.firstElementChild.firstElementChild.style.height = `calc(${this.customHeight} + ${scrollbarWidthSize}px)`
  },
}
</script>

<style>

.el-scrollbar__thumb {
  background-color: #FE838355 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/custom/YlScrollBar.vue